<template>
  <div>
    <b-card>
      <template v-if="allNotifications.length === 0">
        <div class="p-1 text-center">لا توجد إشعارات بعد</div>
      </template>
      <b-list-group class="w-50">
        <b-list-group-item
          v-for="notification in allNotifications"
          :key="notification.id"
          :to="{ name: notification.data.notificationType.name }"
        >
          <div class="d-flex justify-content-between">
            <div>
              <h5>
                <span class="font-weight-bolder">
                  {{ notification.data.title }}
                </span>
              </h5>
              <small class="notification-text">{{
                notification.data.body
              }}</small>
            </div>
            <time>
              {{
                $moment(notification.created_at).format("YYYY-MM-DD , h:mm a")
              }}
            </time>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BListGroup,
  BListGroupItem,
  BContainer,
  BCol,
} from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import { formatDateToHuman } from "@/@core/utils/filter";
export default {
  components: {
    BCard,
    BRow,
    BListGroup,
    BListGroupItem,
    BContainer,
    BCol,
  },

  methods: {
    formatDateToHuman,
    ...mapActions("User", ["readNotifications"]),
  },

  computed: {
    ...mapGetters("User", ["notifications", "allNotifications"]),
  },

  created() {
    this.readNotifications(true);
  },
};
</script>

<style lang="scss" scoped>
[dir="rtl"] .number-display {
  direction: ltr;
  width: fit-content;
  writing-mode: lr;
}
</style>
